import type { InputHTMLAttributes } from 'react'
import { forwardRef } from 'react'

interface Props extends InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, Props>(({ className = '', ...rest }, ref) => {
  return (
    <input
      ref={ref}
      className={[
        'h-9 w-full px-3 rounded-md text-sm',
        'bg-[var(--color-elevated)] border border-[var(--color-border)]',
        'text-[var(--color-text)] placeholder:text-[var(--color-text-subtle)]',
        'hover:border-[var(--color-border-strong)] focus:border-[var(--color-accent)]',
        'focus:outline-none focus:ring-2 focus:ring-[var(--color-accent-soft)]',
        'disabled:opacity-50',
        className,
      ].join(' ')}
      {...rest}
    />
  )
})

Input.displayName = 'Input'
export default Input
